<template>
    <Component :is="variationComponents[slice.variation as keyof typeof variationComponents]" v-bind="props" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {EmbededSlice} from '@prismicio-types';
    import EmbededCalendly from './variations/EmbededCalendly.vue';

    const props = defineProps(getSliceComponentProps<EmbededSlice>());

    const variationComponents = {
        embededCalendly: EmbededCalendly,
    };
</script>
